import React from "react";
import AuthPage from "./account/AuthPage";
export default function Register() {
  return <AuthPage mode="signup" />;
}
